"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Aug 08 2018
 */

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * Codebook item converter.
 *
 * @author Radek Beran
 */


var CodebookItemConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CodebookItemConverter, _DataObjectConverter_);

  function CodebookItemConverter() {
    _classCallCheck(this, CodebookItemConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CodebookItemConverter).apply(this, arguments));
  }

  return CodebookItemConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CodebookItemConverter = CodebookItemConverter;